import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vShow as _vShow, withKeys as _withKeys, withDirectives as _withDirectives, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-2a278df3"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "scratchpad-container" }
const _hoisted_2 = { class: "flex-gap-2" }
const _hoisted_3 = { class: "history-scroll-area scrollbar" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "history-title" }, "History", -1))
const _hoisted_5 = {
  class: "history-list",
  "data-test": "scratchpad-history-list"
}
const _hoisted_6 = ["onClick", "onKeydown"]
const _hoisted_7 = {
  href: "javascript:void(0)",
  class: "history-list-item-link",
  "data-test": "scratchpad-history-item"
}
const _hoisted_8 = ["onClick", "onKeydown"]
const _hoisted_9 = { class: "flex-item" }
const _hoisted_10 = {
  key: 0,
  class: "text-danger"
}

import { ref, onMounted } from "vue";
import { useRoute } from "vue-router";
import ScratchpadPage from "../components/smart-scratchpad/smart-scratchpad.vue";
import {
  createNewChatEntry,
  deleteChatEntry,
  getAllScratchpadEntries,
} from "../components/smart-scratchpad/scratchpad-history";
import { ScratchpadEntryApiModel } from "../api-models";
import { csContext } from "../services/cs-context";


export default /*#__PURE__*/_defineComponent({
  __name: 'scratchpad-page',
  setup(__props) {

const chatHistory = ref<ScratchpadEntryApiModel[]>([]);
const currentChatEntry = ref<ScratchpadEntryApiModel | null>(null);
const deleteError = ref<string | null>(null);

const route = useRoute();

function getHistoryItemTitle(entry: ScratchpadEntryApiModel): string {
  if (!entry.pageTitle) {
    if (!entry.text) {
      return "Untitled";
    }
    return `${entry.text.substring(0, 20)} ...`;
  }

  if (entry.pageTitle.length > 20) {
    return `${entry.pageTitle.substring(0, 20)} ...`;
  }

  return entry.pageTitle;
}

function handleSelectEntry(entry: ScratchpadEntryApiModel): void {
  currentChatEntry.value = entry;
}

function addNewChatToHistory(): void {
  if (currentChatEntry.value) {
    if (chatHistory.value.length === 0 || chatHistory.value[0].text === "") {
      chatHistory.value[0] = currentChatEntry.value;
    } else {
      chatHistory.value.unshift(currentChatEntry.value);
    }
  }
}

function createNewPage(): void {
  const subjectQuery = route.query.subject as string;
  const idQuery = route.query.id as string;
  const authorId = csContext.user.id;
  currentChatEntry.value = createNewChatEntry(authorId, subjectQuery, idQuery);
  addNewChatToHistory();
}

function handleNewPageClick(): void {
  createNewPage();
}

function updateHistoryItem(entry: ScratchpadEntryApiModel): void {
  const index = chatHistory.value.findIndex((item) => item.pageId === entry.pageId);

  if (index !== -1) {
    chatHistory.value.splice(index, 1, entry);
  }
}

async function deleteEntry(entry: ScratchpadEntryApiModel): Promise<void> {
  const response = await deleteChatEntry(entry.authorId, entry.pageId);
  if (response.error) {
    deleteError.value = response.error;
  }

  const index = chatHistory.value.findIndex((item) => item.pageId === entry.pageId);

  if (index !== -1) {
    chatHistory.value.splice(index, 1);
  }
  createNewPage();
}

onMounted(async () => {
  chatHistory.value = await getAllScratchpadEntries();
  createNewPage();
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _createElementVNode("button", {
          onClick: handleNewPageClick,
          class: "btn btn-default-add",
          type: "button"
        }, " New page "),
        _createElementVNode("ul", _hoisted_5, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(chatHistory.value, (entry, index) => {
            return (_openBlock(), _createElementBlock("li", {
              key: '' + entry.pageId + index,
              class: _normalizeClass(["history-list-item", {
              'selected-chat': currentChatEntry.value && entry.pageId === currentChatEntry.value.pageId,
            }]),
              onClick: ($event: any) => (handleSelectEntry(entry)),
              onKeydown: _withKeys(($event: any) => (handleSelectEntry(entry)), ["enter"])
            }, [
              _createElementVNode("a", _hoisted_7, _toDisplayString(getHistoryItemTitle(entry)), 1),
              _withDirectives(_createElementVNode("span", {
                class: "glyphicon glyphicon-trash",
                onClick: ($event: any) => (deleteEntry(entry)),
                onKeydown: _withKeys(($event: any) => (deleteEntry(entry)), ["enter"])
              }, null, 40, _hoisted_8), [
                [_vShow, currentChatEntry.value && entry.pageId === currentChatEntry.value.pageId]
              ])
            ], 42, _hoisted_6))
          }), 128))
        ])
      ]),
      _createElementVNode("div", _hoisted_9, [
        (deleteError.value)
          ? (_openBlock(), _createElementBlock("p", _hoisted_10, _toDisplayString(deleteError.value), 1))
          : _createCommentVNode("", true),
        (currentChatEntry.value)
          ? (_openBlock(), _createBlock(ScratchpadPage, {
              key: 1,
              currentChat: currentChatEntry.value,
              onUpdateHistoryItem: updateHistoryItem
            }, null, 8, ["currentChat"]))
          : _createCommentVNode("", true)
      ])
    ])
  ]))
}
}

})